import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useAgenda from "./hooks/useAgenda";

import AgendaHeader from "./components/AgendaHeader";
import AgendaStats from "./components/AgendaStats";
import AgendaTable from "./components/AgendaTable";
import EventFormDrawer from "./components/EventFormDrawer";

const Agenda = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    loading,
    saving,
    demoMode,

    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    periodFilter,
    setPeriodFilter,

    drawer,
    openCreateDrawer,
    openEditDrawer,
    closeDrawer,

    fetchEvents,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useAgenda(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <AgendaHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={fetchEvents}
          onCreate={openCreateDrawer}
        />

        <AgendaStats stats={stats} />

        <AgendaTable
          rows={rows}
          loading={loading}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          periodFilter={periodFilter}
          onSearchChange={setSearchTerm}
          onStatusFilterChange={setStatusFilter}
          onPeriodFilterChange={setPeriodFilter}
          onEdit={openEditDrawer}
          onDelete={handleDelete}
        />
      </div>

      <EventFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreate}
      />

      <EventFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        event={drawer.event}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdate}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default Agenda;